import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetStoresResquestParams,
  type StoresResponse,
  getStoresFn,
} from './ahafood/get-store-fn';
import { createStoreQueryKey } from '@/lib/query-key-utils';

export const useGetStores = (
  params: GetStoresResquestParams,
  opts?: Omit<UseQueryOptions<StoresResponse, Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<StoresResponse, Error>({
    queryKey: createStoreQueryKey(params), // Use normalized geohash-based key
    queryFn: () => getStoresFn(params), // Still pass exact lat/lng to API
    ...opts,
  });
};
